import { useState } from "react";
import { ChevronDown, Plus, Database } from "lucide-react";
import { DATA_CATALOG, type CatalogItem } from "./types";
import { useTranslation } from "../../i18n";

export function DataSourcePanel({ onAdd }: { onAdd: (item: CatalogItem) => void }) {
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});
  const { t } = useTranslation();

  return (
    <div>
      <div className="mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-gray-500">
        <Database size={16} /> {t("reportBuilder.dataFields", "Data fields")}
      </div>
      <p className="mb-3 text-xs text-gray-400">{t("reportBuilder.dataFieldsHint", "Click any field to drop a pre-built widget onto your report.")}</p>
      <div className="space-y-2">
        {DATA_CATALOG.map((group) => {
          const isCollapsed = collapsed[group.id];
          return (
            <div key={group.id} className="rounded-lg border border-gray-200">
              <button
                onClick={() => setCollapsed((c) => ({ ...c, [group.id]: !c[group.id] }))}
                className="flex w-full items-center justify-between rounded-lg px-3 py-2 text-left text-sm font-semibold text-gray-800 hover:bg-gray-50"
              >
                {group.label}
                <ChevronDown size={15} className={`text-gray-400 transition-transform ${isCollapsed ? "-rotate-90" : ""}`} />
              </button>
              {!isCollapsed && (
                <div className="space-y-0.5 px-1.5 pb-2">
                  {group.items.map((item, i) => (
                    <button
                      key={i}
                      onClick={() => onAdd(item)}
                      className="group flex w-full items-center justify-between gap-2 rounded-md px-2 py-1.5 text-left text-xs text-gray-600 hover:bg-blue-50 hover:text-blue-900"
                    >
                      <span className="truncate">{item.label}</span>
                      <Plus size={13} className="shrink-0 text-gray-300 group-hover:text-blue-600" />
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
